function ThirdPillarSuccess(config) {
  let calculator = new Calculator2021(CalculatorConfiguration, fundShares)

  this.init = function (urlParams) {
    let incomeTaxBenefitPerMonth = Math.round(CalculatorConfiguration.maximumIncomeTaxBenefit / 12 )

    return {
      showTitle: !session.pension.thirdPillar.assets.length,
      signedDocumentId: urlParams.signedDocumentId,
      sliderMinimum: 0,
      sliderValue: Math.min(session.pension.thirdPillar.lastPayment.total, incomeTaxBenefitPerMonth),
      sliderMaximum: incomeTaxBenefitPerMonth,
      estimation: calculator.calculate(session.pension, session.pension.thirdPillar.averageMonthlyContribution).total.toFixed(2),
      banklinkPaymentUrl: config.banklinkPaymentUrl
    }
  }

  this.done = function () {
    let thirdPillarOffer = new ThirdPillarOffer()
    thirdPillarOffer.init()
  }
}